import { apiRequest } from '../../../api/client';
import type { TaskReportResponse } from '../../../api/types';

export async function fetchReport(from: string, to: string): Promise<TaskReportResponse> {
  const params = new URLSearchParams({ from, to });
  return apiRequest<TaskReportResponse>(`/reports?${params.toString()}`);
}
